// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCustomerProfileApi } from "../../services/Api/CustomerProfileApi"
import { getCustomerProfileList,getErrors } from "../reducers/CustomerProfileReducer"
 

// Watchers
function* customerProfileSaga() {
	yield takeEvery("customerProfile_list/getCustomerProfile", getCustomer)
}

// Sagas
function* getCustomer(action) {
	// console.log(action)
	try {
		const getCustomerProfile = yield call(getCustomerProfileApi, action.payload)
		// console.log(getCustomerProfile.status);
		if (getCustomerProfile.request.status === 200) {
			yield put(getCustomerProfileList(getCustomerProfile))
			// console.log(getCustomerProfile.status);
		} else {
			yield put(getErrors(getCustomerProfile))
		}
	} catch (error) {

		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(customerProfileSaga)])
}
